module.exports = __webpack_public_path__ + "img/loupe.a4b1ae01.png";